// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/css/style.css
// module id = 13
// module chunks = 0